import "./Login.less";

import { Alert, App as AntdApp, Button, Checkbox, Form, Input, theme } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { apiClient } from "src/api/client";
import { useAuth } from "src/features/auth/AuthContext";
import { UserProfileVO } from "src/models/UserProfile";

import { LockOutlined, LoginOutlined, UserOutlined } from "@ant-design/icons";

const Login = () => {
  const { token } = theme.useToken();
  const { message } = AntdApp.useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const queryParams = new URLSearchParams(location.search);
  const tokenExpired = location.state?.tokenExpired || queryParams.get("tokenExpired") === "true";

  const handleSubmit = async (values: any) => {
    try {
      // 로그인은 {code,message,data} 래핑 응답 — apiClient.post가 unwrapData로 최종 data 반환
      const profile = await apiClient.post<UserProfileVO>("/v1/auth/login", {
        email: values.email,
        password: values.password,
        remember: values.remember,
      });
      if (profile) {
        login(profile);
        navigate("/");
      }
    } catch (error: any) {
      message.error(error.message || "로그인 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="login" style={{ backgroundColor: token.colorBgContainer }}>
      <div className="main">
        <div className="aligner">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 4 }}>
            <img src="/finhub-icon.svg" alt="FinHub" width={30} height={30} style={{ display: "block" }} />
            <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>FinHub</h1>
          </div>
          {tokenExpired && <Alert type="warning" message="토큰이 만료되었습니다." banner closable />}
        </div>
        <div>
          <Form onFinish={handleSubmit} className="login-form" initialValues={{ remember: true }}>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "이메일을 입력해주세요." },
                { type: "email", message: "올바른 이메일 형식이 아닙니다." },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Email" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "비밀번호를 입력해주세요." }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="Password" />
            </Form.Item>
            <Form.Item name="remember" valuePropName="checked">
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <Form.Item>
              <Button block type="primary" htmlType="submit" className="login-form-button" icon={<LoginOutlined />}>
                Log in
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
